import { useEffect, useState } from 'react';
import { ExtraTableResize } from '../../extraTableResize';
import TableComponent from '../../TableComponent';

interface IProps {
  dataColor: any[];
  rowIndex: number;
  changeRowIndex: (rowIndex: number) => void; // 行を選択する
}

const ColorSearchTable: React.FC<IProps> = (props: IProps) => {
  const columnInit: any = [
    {
      title: '表示色調',
      dataIndex: 'hyoujiIroCd',
      width: 50,
      ellipsis: true,
    },
    {
      title: '基本色調',
      dataIndex: 'kihonIroCd',
      width: 50,
      ellipsis: true,
    },
    {
      title: '現物管理No.',
      dataIndex: 'genbutuNo',
      width: 50,
      ellipsis: true,
    },
    {
      title: '見本板管理No.',
      dataIndex: 'mihonNo',
      width: 50,
      ellipsis: true,
    },
    {
      title: '製品名',
      dataIndex: 'hinNm',
      width: 100,
      ellipsis: true,
    },
  ];

  const [columns, changeColumns] = useState(columnInit);
  const [rIdx, changeRowIndex] = useState(-1);

  useEffect(() => {
    if (rIdx >= 0) {
      props.changeRowIndex(rIdx);
      changeRowIndex(-1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rIdx]);

  return (
    <>
      <ExtraTableResize>
        <TableComponent
          columns={columns}
          data={props.dataColor}
          minHeight="35vh"
          maxHeight="35vh"
          updateColumns={changeColumns}
          rowIndex={rIdx}
          changeRowIndex={changeRowIndex}
        />
      </ExtraTableResize>
    </>
  );
};
export default ColorSearchTable;
